export default "__VITE_ASSET__CDQhEEIx__"